import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const YearContext = createContext(null);

export function YearProvider({ children }) {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [years, setYears] = useState([currentYear]);

  const refreshYears = async () => {
    try {
      const { data } = await api.get("/reports/years");
      if (data?.years?.length) setYears(data.years);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    refreshYears();
  }, []);

  return (
    <YearContext.Provider value={{ year, setYear, years, refreshYears }}>
      {children}
    </YearContext.Provider>
  );
}

export const useYear = () => useContext(YearContext);
